export default function isMobile() {
  const mobileBreakpoint = 768;
  if (window.innerWidth < mobileBreakpoint) {
    return true;
  }
  return false;
}



// WEBPACK FOOTER //
// ./js/utils/isMobile.js